import { motion } from "framer-motion";

const certs = [
  { code: "R2v3", label: "Responsible Recycling" },
  { code: "ISO 27001", label: "Information Security" },
  { code: "ISO 14001", label: "Environmental Mgmt" },
  { code: "NIST 800-88", label: "Media Sanitization" },
  { code: "ADISA", label: "Asset Disposal Assurance" },
  { code: "GDPR", label: "Data Protection" },
];

export default function Certifications() {
  return (
    <section id="certifications" className="bg-background py-20 md:py-32 border-b border-border" data-testid="certifications-section">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary mb-4">/ Compliance</p>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl leading-[0.9]">
              Audit-ready by default.
            </h2>
          </div>
          <p className="md:col-span-5 font-sans text-muted-foreground leading-relaxed">
            Every engagement is backed by internationally recognized standards and a documented
            paper trail your auditors and DPO will actually approve of.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-border">
          {certs.map((c, i) => (
            <motion.div
              key={c.code}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`cert-${c.code.replace(/\s+/g, "-").toLowerCase()}`}
              className="border-r border-b border-border p-6 md:p-8 flex flex-col justify-between aspect-square hover:bg-secondary hover:text-white transition-colors group"
            >
              <div className="h-8 w-8 border-2 border-primary group-hover:border-white flex items-center justify-center">
                <div className="h-2 w-2 bg-primary group-hover:bg-white" />
              </div>
              <div>
                <div className="font-display font-extrabold text-2xl tracking-tight">{c.code}</div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground group-hover:text-white/70 mt-1">{c.label}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
